import { Paper, PaperProps, Typography } from '@mui/material';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

interface Props extends PaperProps {
  query?: string;
}

export default function SearchNotFound({ query, sx, ...other }: Props) {
  const { translate } = useLocales();
  return query ? (
    <Paper
      sx={{
        textAlign: 'center',
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h6" paragraph>
        {`${translate('searchNotFound.noResults')}`}
      </Typography>

      <Typography variant="body2">
        {`${translate('searchNotFound.noResultsFor')}`} &nbsp;
        <strong>&quot;{query}&quot;</strong>.
        <br /> {`${translate('searchNotFound.tryAgain')}`}
      </Typography>
    </Paper>
  ) : (
    <Typography variant="body2" sx={sx}>
      {`${translate('searchNotFound.typeToSearch')}`}
    </Typography>
  );
}
